import React, { Component } from 'react';
import styled from 'styled-components';
import { Container } from 'reactstrap';
/* 
Name: Article
Function: Represents a Header and its Text
Props:
    header: string | string[] 
    text: string | string[]
*/
export default class Article extends Component {
    render() {
        const { header, text } = this.props.options;
        return (
            <Container>
                <Header>
                    {header.map((h, i) => {
                        return (
                            <h1 key={i * 13}>{h}</h1>
                        );
                    })}
                </Header>
                <Text>
                    {text.map((t, i) => {
                        return (
                            <p key={i * 7}>{t}</p>
                        );
                    })}
                </Text>
            </Container>
        );
    }
}

const Header = styled.div`
    padding: 5rem 0 5rem 0;
`;

const Text = styled.div`
    padding-bottom: 5rem;
`;